/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Traces_Filters_TypeInputs */

const es_admin_traces_filters_type = /** @type {(inputs: Admin_Traces_Filters_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtrar tipo`)
};

const en_admin_traces_filters_type = /** @type {(inputs: Admin_Traces_Filters_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter type`)
};

/**
* | output |
* | --- |
* | "Filter type" |
*
* @param {Admin_Traces_Filters_TypeInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_traces_filters_type = /** @type {((inputs?: Admin_Traces_Filters_TypeInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Traces_Filters_TypeInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_traces_filters_type(inputs)
	return en_admin_traces_filters_type(inputs)
});
export { admin_traces_filters_type as "admin.traces.filters.type" }